export var validationUtil = (function() {
    var validateAbn = function(abn) {
        if (!abn || abn.length != 11) {
            return false;
        }

        abn = String(parseInt(abn, 10) - 10000000000);

        var weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
        var sum = 0;

        for (var i=10; i >= 0; i--) {
            sum += parseInt(abn.charAt(i), 10) * weights[i];
        }
        return sum % 89 === 0;
    };

    return {
        validateAbn: validateAbn
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/validation-util.js
// module id = 338
// module chunks = 0